"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BannerSection36sItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/banner-icon-01.svg" | "/Templates/Doccure/img/icons/banner-icon-02.svg" | "/Templates/Doccure/img/icons/banner-icon-03.svg" | "/Templates/Doccure/img/icons/banner-icon-04.svg" */
    src: string;
    /** Detected variants: "Supplements" | "Diabetes" | "Cosmetics" | "Oral Care" */
    p0Text: ReactNode;
    /** Detected variants: "col-md-3 col-sm-6 d-flex" */
    className?: string;
    /** Detected variants: "banner-item flex-fill" */
    div0ClassName?: string;
    /** Detected variants: "banner-icon" */
    div0ClassName2?: string;
    /** Detected variants: "icon" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "sub-title" */
    p0ClassName?: string;
};

type BannerSectionDivsItem = {
    key: Key | null | undefined;
    /** Detected variants: "all_routes.pharmacySearch" | "all_routes.cart" | "#" | "all_routes.pharmacyRegister" */
    href: string;
    /** Detected variants: "isax isax-shop" | "isax isax-shopping-cart" | "isax isax-heart" | "isax isax-user" */
    className: string;
    /** Detected variants: "badge" */
    span0ClassName?: string;
};
export type HomeThirteenBannerSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    linkLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BannerSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
    sectionDiv0Div0ClassName?: string;
    /** Default: "0.2s" */
    sectionDiv0Div0Div0Div0DivDataWowDelay?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div0Div0DivDataWowDuration?: string;
    /** Default: "all_routes.pharmacySearch" */
    sectionDiv0Div0Div0Div0Div0Link0LinkHref?: string;
    /** Default: "Shop Medicines" */
    sectionDiv0Div0Div0Div0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "all_routes.search1" */
    sectionDiv0Div0Div0Div0Div0Link1LinkHref?: string;
    /** Default: "Upload Prescription" */
    sectionDiv0Div0Div0Div0Div0Link1LinkText?: ReactNode;
    sectionDiv0Div0Div0Div0Div0Link1LinkVisible?: boolean;
    sectionDiv0Div0Div0Div0Div0Link1LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0Div0Link1LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv0Div0Div0Div0Div1ClassName?: string;
    /** Default: "Your Trusted" */
    sectionDiv0Div0Div0Div0H10H1Text?: ReactNode;
    sectionDiv0Div0Div0Div0H10H1Visible?: boolean;
    sectionDiv0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "icon" */
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/icons/banner-icon.svg" */
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Online Pharmacy" */
    sectionDiv0Div0Div0Div0H10Span1SpanText?: ReactNode;
    /** Default: "Safe medicines, fast delivery, and professional guidance all in one place. We are a certified online pharmacy committed to making healthcare simple, safe, and affordable." */
    sectionDiv0Div0Div0Div0P0PText?: ReactNode;
    /** Default: "0.2s" */
    sectionDiv0Div0Div1Div0DivDataWowDelay?: string;
    /** Default: "1s" */
    sectionDiv0Div0Div1Div0DivDataWowDuration?: string;
    /** Default: "banner" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-06.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "icon" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-bg-08.png" */
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc?: string;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible?: boolean;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "Pharmacy" */
    sectionDiv0H20H2Text?: ReactNode;
    sectionDiv0H20H2Visible?: boolean;
    sectionDiv0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "bg" */
    sectionImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-18.png" */
    sectionImageWithBasePath0ImageSrc?: string;
    sectionImageWithBasePath0ImageVisible?: boolean;
    sectionImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-19.png" */
    sectionImageWithBasePath1ImageSrc?: string;
    sectionImageWithBasePath1ImageVisible?: boolean;
    sectionImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-20.png" */
    sectionImageWithBasePath2ImageSrc?: string;
    sectionImageWithBasePath2ImageVisible?: boolean;
    sectionImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath3ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-bg-04.png" */
    sectionImageWithBasePath3ImageSrc?: string;
    sectionImageWithBasePath3ImageVisible?: boolean;
    sectionImageWithBasePath3ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath3ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath4ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-bg-05.png" */
    sectionImageWithBasePath4ImageSrc?: string;
    sectionImageWithBasePath4ImageVisible?: boolean;
    sectionImageWithBasePath4ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath4ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "bg" */
    sectionImageWithBasePath5ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/bg/banner-bg-07.png" */
    sectionImageWithBasePath5ImageSrc?: string;
    sectionImageWithBasePath5ImageVisible?: boolean;
    sectionImageWithBasePath5ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionImageWithBasePath5ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    bannerSection36s: BannerSection36sItem[];
    bannerSectionDivs: BannerSectionDivsItem[];
    bannerSection36sItemWrapper?: (item: BannerSection36sItem, content: ReactNode) => ReactNode;
    bannerSection36sRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSection36sImageVisible?: boolean;
    bannerSection36sImageRenderer?: (item: BannerSection36sItem, defaultNode: ReactNode) => ReactNode;
    bannerSection36sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSection36sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerSectionDivsItemWrapper?: (item: BannerSectionDivsItem, content: ReactNode) => ReactNode;
    bannerSectionDivsRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionDivsLinkVisible?: boolean;
    bannerSectionDivsLinkRenderer?: (item: BannerSectionDivsItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionDivsLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BannerSectionDivsItem) => Partial<ComponentProps<typeof SmartLink>>);
};

const HomeThirteenBannerSectionGenerated: FC<HomeThirteenBannerSectionGeneratedProps> = ({
    sectionDiv0Div0Div0Div0Div0Link0LinkHref = "all_routes.pharmacySearch",
    sectionDiv0Div0Div0Div0Div0Link0LinkText = "Shop Medicines",
    sectionDiv0Div0Div0Div0Div0Link0LinkVisible,
    sectionDiv0Div0Div0Div0Div0Link0LinkRenderer,
    sectionDiv0Div0Div0Div0Div0Link0LinkProps,
    sectionDiv0Div0Div0Div0Div0Link1LinkHref = "all_routes.search1",
    sectionDiv0Div0Div0Div0Div0Link1LinkText = "Upload Prescription",
    sectionDiv0Div0Div0Div0Div0Link1LinkVisible,
    sectionDiv0Div0Div0Div0Div0Link1LinkRenderer,
    sectionDiv0Div0Div0Div0Div0Link1LinkProps,
    sectionDiv0Div0Div0Div0DivDataWowDelay = "0.2s",
    sectionDiv0Div0Div0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div0Div0H10H1Text = "Your Trusted",
    sectionDiv0Div0Div0Div0H10H1Visible,
    sectionDiv0Div0Div0Div0H10H1Renderer,
    sectionDiv0Div0Div0Div0H10H1Props,
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageAlt = "icon",
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/icons/banner-icon.svg",
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div0Div0H10Span1SpanText = "Online Pharmacy",
    sectionDiv0Div0Div0Div0P0PText = "Safe medicines, fast delivery, and professional guidance all in one place. We are a certified online pharmacy committed to making healthcare simple, safe, and affordable.",
    sectionDiv0Div0Div1Div0DivDataWowDelay = "0.2s",
    sectionDiv0Div0Div1Div0DivDataWowDuration = "1s",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt = "banner",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-06.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt = "icon",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-bg-08.png",
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer,
    sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps,
    sectionDiv0H20H2Text = "Pharmacy",
    sectionDiv0H20H2Visible,
    sectionDiv0H20H2Renderer,
    sectionDiv0H20H2Props,
    sectionImageWithBasePath0ImageAlt = "bg",
    sectionImageWithBasePath0ImageSrc = "/Templates/Doccure/img/bg/banner-18.png",
    sectionImageWithBasePath0ImageVisible,
    sectionImageWithBasePath0ImageRenderer,
    sectionImageWithBasePath0ImageProps,
    sectionImageWithBasePath1ImageAlt = "bg",
    sectionImageWithBasePath1ImageSrc = "/Templates/Doccure/img/bg/banner-19.png",
    sectionImageWithBasePath1ImageVisible,
    sectionImageWithBasePath1ImageRenderer,
    sectionImageWithBasePath1ImageProps,
    sectionImageWithBasePath2ImageAlt = "bg",
    sectionImageWithBasePath2ImageSrc = "/Templates/Doccure/img/bg/banner-20.png",
    sectionImageWithBasePath2ImageVisible,
    sectionImageWithBasePath2ImageRenderer,
    sectionImageWithBasePath2ImageProps,
    sectionImageWithBasePath3ImageAlt = "bg",
    sectionImageWithBasePath3ImageSrc = "/Templates/Doccure/img/bg/banner-bg-04.png",
    sectionImageWithBasePath3ImageVisible,
    sectionImageWithBasePath3ImageRenderer,
    sectionImageWithBasePath3ImageProps,
    sectionImageWithBasePath4ImageAlt = "bg",
    sectionImageWithBasePath4ImageSrc = "/Templates/Doccure/img/bg/banner-bg-05.png",
    sectionImageWithBasePath4ImageVisible,
    sectionImageWithBasePath4ImageRenderer,
    sectionImageWithBasePath4ImageProps,
    sectionImageWithBasePath5ImageAlt = "bg",
    sectionImageWithBasePath5ImageSrc = "/Templates/Doccure/img/bg/banner-bg-07.png",
    sectionImageWithBasePath5ImageVisible,
    sectionImageWithBasePath5ImageRenderer,
    sectionImageWithBasePath5ImageProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    linkLinkProps,
    sectionDiv0Div0ClassName,
    sectionDiv0Div0Div0Div0Div1ClassName,
    bannerSection36s,
    bannerSectionDivs,
    bannerSection36sItemWrapper,
    bannerSection36sRenderer,
    bannerSection36sImageVisible,
    bannerSection36sImageRenderer,
    bannerSection36sImageProps,
    bannerSectionDivsItemWrapper,
    bannerSectionDivsRenderer,
    bannerSectionDivsLinkVisible,
    bannerSectionDivsLinkRenderer,
    bannerSectionDivsLinkProps,
}) => {
    return (
        <section className="banner-section-thirteen">
            <div className="container">
                <div className={sectionDiv0Div0ClassName ?? "row align-items-end"}>
                    <div className="col-xl-7">
                        <div className="banner-content wow fadeInUp" data-wow-delay={sectionDiv0Div0Div0Div0DivDataWowDelay} data-wow-duration={sectionDiv0Div0Div0Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div0Div0H10H1Visible, sectionDiv0Div0Div0Div0H10H1Renderer, (
                                <h1 {...(sectionDiv0Div0Div0Div0H10H1Props ?? {})}>
                                    {sectionDiv0Div0Div0Div0H10H1Text}
                                    {" "}
                                    <span className="banner-icon">
                                        {renderNode(sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageRenderer, (
                                            <SmartImage src={sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageSrc} alt={sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageAlt} className="img-fluid" {...(sectionDiv0Div0Div0Div0H10Span0ImageWithBasePath0ImageProps ?? {})} />
                                        ))}
                                    </span>
                                    {" "}
                                    <span>{sectionDiv0Div0Div0Div0H10Span1SpanText}</span>
                                </h1>
                            ))}
                            <p>
                                {sectionDiv0Div0Div0Div0P0PText}
                                {" "}
                            </p>
                            <div className="banner-btns">
                                {renderNode(sectionDiv0Div0Div0Div0Div0Link0LinkVisible, sectionDiv0Div0Div0Div0Div0Link0LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Div0Link0LinkHref} className="btn btn-secondary theme-13-btn" {...(sectionDiv0Div0Div0Div0Div0Link0LinkProps ?? {})}>
                                        <span className="icon">
                                            <i className="isax isax-bag-happy" />
                                        </span>
                                        {sectionDiv0Div0Div0Div0Div0Link0LinkText}
                                    </SmartLink>
                                ))}
                                {renderNode(sectionDiv0Div0Div0Div0Div0Link1LinkVisible, sectionDiv0Div0Div0Div0Div0Link1LinkRenderer, (
                                    <SmartLink href={sectionDiv0Div0Div0Div0Div0Link1LinkHref} className="btn btn-white theme-13-btn" {...(sectionDiv0Div0Div0Div0Div0Link1LinkProps ?? {})}>
                                        <input type="file" className="form-control position-absolute w-100 h-100 top-0 start-0 opacity-0" />
                                        <span className="icon">
                                            <i className="isax isax-document-upload" />
                                        </span>
                                        {sectionDiv0Div0Div0Div0Div0Link1LinkText}
                                    </SmartLink>
                                ))}
                            </div>
                            <div className={sectionDiv0Div0Div0Div0Div1ClassName ?? "row g-4"}>
                                {renderCollectionNode(
                                    bannerSection36s,
                                    (item: BannerSection36sItem) => (
                                        <div className={item.className ?? "col-md-3 col-sm-6 d-flex"} key={item.key}>
                                            <div className={item.div0ClassName ?? "banner-item flex-fill"}>
                                                <div className={item.div0ClassName2 ?? "banner-icon"}>
                                                    {renderItemNode(bannerSection36sImageVisible, bannerSection36sImageRenderer, item, (
                                                        <SmartImage src={item.src} alt={item.alt ?? "icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof bannerSection36sImageProps === "function" ? bannerSection36sImageProps(item) : (bannerSection36sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                                    ))}
                                                </div>
                                                <p className={item.p0ClassName ?? "sub-title"}>{item.p0Text}</p>
                                            </div>
                                        </div>
                                    ),
                                    bannerSection36sItemWrapper,
                                    bannerSection36sRenderer
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5">
                        <div className="banner-img wow fadeInUp" data-wow-delay={sectionDiv0Div0Div1Div0DivDataWowDelay} data-wow-duration={sectionDiv0Div0Div1Div0DivDataWowDuration}>
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageSrc} className="img-fluid banner-image" alt={sectionDiv0Div0Div1Div0ImageWithBasePath0ImageAlt} {...(sectionDiv0Div0Div1Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageVisible, sectionDiv0Div0Div1Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageSrc} alt={sectionDiv0Div0Div1Div0ImageWithBasePath1ImageAlt} className="banner-bg-07" {...(sectionDiv0Div0Div1Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                </div>
                <div className="banner-links">
                    {renderCollectionNode(
                        bannerSectionDivs,
                        (item: BannerSectionDivsItem) => (
                            renderItemNode(bannerSectionDivsLinkVisible, bannerSectionDivsLinkRenderer, item, (
                                <SmartLink href={item.href} {...(typeof bannerSectionDivsLinkProps === "function" ? bannerSectionDivsLinkProps(item) : (bannerSectionDivsLinkProps ?? {}))} {...(typeof linkLinkProps === "function" ? linkLinkProps(item) : (linkLinkProps ?? {}))} key={item.key}>
                                    <i className={item.className} />
                                    <span className={item.span0ClassName} />
                                </SmartLink>
                            ))
                        ),
                        bannerSectionDivsItemWrapper,
                        bannerSectionDivsRenderer
                    )}
                </div>
                {renderNode(sectionDiv0H20H2Visible, sectionDiv0H20H2Renderer, (
                    <h2 {...(sectionDiv0H20H2Props ?? {})}>{sectionDiv0H20H2Text}</h2>
                ))}
            </div>
            {renderNode(sectionImageWithBasePath0ImageVisible, sectionImageWithBasePath0ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath0ImageSrc} alt={sectionImageWithBasePath0ImageAlt} className="banner-bg-01" {...(sectionImageWithBasePath0ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath1ImageVisible, sectionImageWithBasePath1ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath1ImageSrc} alt={sectionImageWithBasePath1ImageAlt} className="banner-bg-02" {...(sectionImageWithBasePath1ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath2ImageVisible, sectionImageWithBasePath2ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath2ImageSrc} alt={sectionImageWithBasePath2ImageAlt} className="banner-bg-03" {...(sectionImageWithBasePath2ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath3ImageVisible, sectionImageWithBasePath3ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath3ImageSrc} alt={sectionImageWithBasePath3ImageAlt} className="banner-bg-04" {...(sectionImageWithBasePath3ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath4ImageVisible, sectionImageWithBasePath4ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath4ImageSrc} alt={sectionImageWithBasePath4ImageAlt} className="banner-bg-05" {...(sectionImageWithBasePath4ImageProps ?? {})} />
            ))}
            {renderNode(sectionImageWithBasePath5ImageVisible, sectionImageWithBasePath5ImageRenderer, (
                <SmartImage src={sectionImageWithBasePath5ImageSrc} alt={sectionImageWithBasePath5ImageAlt} className="banner-bg-06" {...(sectionImageWithBasePath5ImageProps ?? {})} />
            ))}
        </section>
    );
};

export default HomeThirteenBannerSectionGenerated;
